function buildGuard(mode) {
    return function (parent, settings) {
        return settings.mode === mode;
    };
}
export var isOnBootParent = buildGuard('onBoot');
export var isRenderPageParent = buildGuard('renderPage');
export var isRenderConfigScreenParent = buildGuard('renderConfigScreen');
export var isRenderModalParent = buildGuard('renderModal');
export var isRenderSidebarPanelParent = buildGuard('renderItemFormSidebarPanel');
export var isRenderSidebarParent = buildGuard('renderItemFormSidebar');
export var isRenderItemFormOutletParent = buildGuard('renderItemFormOutlet');
export var isRenderFieldExtensionParent = buildGuard('renderFieldExtension');
export var isRenderManualFieldExtensionConfigScreenParent = buildGuard('renderManualFieldExtensionConfigScreen');
export var isRenderAssetSourceParent = buildGuard('renderAssetSource');
//# sourceMappingURL=guards.js.map